/**
 * Gebäude-Konfiguration. Definitionen aller 7 Gebäude-Typen mit
 * Basis-Werten für Produktion, Energie und Kapazität.
 */
import type { BuildingType, BuildingDef } from './BuildingTypes';

export const BUILDING_DEFS: Record<BuildingType, BuildingDef> = {
  feronium_mine: {
    type: 'feronium_mine', category: 'factory',
    name: 'Feronium-Mine', icon: 'feronium_mine.png',
    maxLevel: 100, baseRate: 5, baseEnergy: 20,
    costWeights: { feronium: 1.4, chrysalium: 0.8, neurogel: 0.8 },
  },
  chrysalium_burner: {
    type: 'chrysalium_burner', category: 'factory',
    name: 'Chrysalium-Brenner', icon: 'chrysalium_burner.png',
    maxLevel: 100, baseRate: 5, baseEnergy: 20,
    costWeights: { feronium: 1.4, chrysalium: 0.7, neurogel: 0.9 },
  },
  neurogel_extractor: {
    type: 'neurogel_extractor', category: 'factory',
    name: 'Neurogel-Extraktor', icon: 'neurogel_extractor.png',
    maxLevel: 100, baseRate: 5, baseEnergy: 20,
    costWeights: { feronium: 1.4, chrysalium: 0.9, neurogel: 0.7 },
  },
  solar_collector: {
    type: 'solar_collector', category: 'factory',
    name: 'Solar-Kollektor', icon: 'solar_collector.png',
    maxLevel: 100, baseRate: 50, baseEnergy: 0,
    costWeights: { feronium: 1.0, chrysalium: 1.0, neurogel: 1.0 },
  },
  feronium_storage: {
    type: 'feronium_storage', category: 'storage',
    name: 'Feronium-Lager', icon: 'feronium_storage.png',
    maxLevel: 100, baseRate: 1000, baseEnergy: 0,
    costWeights: { feronium: 1.4, chrysalium: 0.8, neurogel: 0.8 },
  },
  chrysalium_storage: {
    type: 'chrysalium_storage', category: 'storage',
    name: 'Chrysalium-Lager', icon: 'chrysalium_storage.png',
    maxLevel: 100, baseRate: 1000, baseEnergy: 0,
    costWeights: { feronium: 0.8, chrysalium: 1.4, neurogel: 0.8 },
  },
  neurogel_tank: {
    type: 'neurogel_tank', category: 'storage',
    name: 'Neurogel-Tank', icon: 'neurogel_tank.png',
    maxLevel: 100, baseRate: 1000, baseEnergy: 0,
    costWeights: { feronium: 0.8, chrysalium: 0.8, neurogel: 1.4 },
  },
};

/** Basis-Kosten pro Ressource für ein Upgrade (Level 0→1). */
export const UPGRADE_COST_BASE = 10;

/** Additiv für Early Game: cost = ADD + BASE × growth^(lv-1). Progression von Anfang an. SYNC mit upgrade-building. */
export const UPGRADE_COST_ADD = 150;

/** Kosten-Wachstum pro Level (×1.15 exponentiell). SYNC mit supabase/functions/upgrade-building. */
export const COST_GROWTH = 1.15;

/** Upgrade-Bauzeit in Sekunden für Level 1. SYNC mit supabase/functions/upgrade-building. */
export const UPGRADE_TIME_BASE = 5;

/** Bauzeit-Wachstum pro Level (×1.10 exponentiell). SYNC mit supabase/functions/upgrade-building. */
export const UPGRADE_TIME_GROWTH = 1.10;

/** Max gleichzeitige Upgrades pro Planet. Später durch Spieler-Stufe erhöhbar. */
export const MAX_CONCURRENT_UPGRADES = 2;

/** Storage-Kurve (stückweise). SYNC mit upgrade-building & tick-planet. */
export const STORAGE_SEG1_TARGET = 600_000;   // Kapazität am Ende Segment 1 (Lv74)
export const STORAGE_SEG1_MAX_LEVEL = 74;
export const STORAGE_SEG2_START = 1e6;         // Kapazität bei Lv75 (Einstieg Mio)
export const STORAGE_MAX = 66e6;               // Kapazität bei Lv100
